import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import './FloatingCTA.css';

const FloatingCTA = () => {
  return (
    <div className="floating-cta">
      <motion.a
        href="https://wa.me/34654384937"
        className="floating-button whatsapp"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1 }}
      >
        <FaWhatsapp />
        <span className="button-text">WhatsApp</span>
      </motion.a>
      
      <motion.a
        href="tel:+34654384937"
        className="floating-button phone"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1.2 }}
      >
        <FaPhone />
        <span className="button-text">Llamar</span>
      </motion.a>
    </div>
  );
};

export default FloatingCTA; 